import "./Page.styl";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import Match from "../components/Match";

import { Container, Row, Col, Button } from "reactstrap";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import ButtonWithLoader from "../components/Form/ButtonWithLoader";

class Page extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { pathname } = this.props;

    const seoTitle = "Dodaj Ogłoszenie";
    const seoDescription = "Dodaj ogłoszenia do naszego portalu za darmo!";

    return (
      <div className="add-page">
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            {
              property: "og:image",
              content: "https://opiekujsie.pl/static/lockstep.jpg"
            }
          ]}
        />
        <Header />

        <div className="add-section">
          <div className="add-wrapper">
            <div className="image" />
            <div className="content">
              <h1>
                <div className="description">
                  Dodawaj ogłoszenia zupełnie <strong>za darmo!</strong>
                </div>
              </h1>
              <hr />
              <div className="text">
                Zarejestruj się w portalu aby móc dodawać ogłoszenia za darmo.
              </div>
              <div className="button">
                <ButtonWithLoader
                  tag="a"
                  className="mr-1"
                  href="https://app.opiekujsie.pl/signup"
                  size="lg"
                  color="secondary"
                  text="Utwórz konto"
                />
                <ButtonWithLoader
                  tag="a"
                  href="https://app.opiekujsie.pl/signin"
                  size="lg"
                  color="primary"
                  text="Zaloguj się"
                />
              </div>
            </div>
          </div>
        </div>

        <Footer noNewsletter />
      </div>
    );
  }
}

Page.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(state => ({}), {})(Page);



/** WEBPACK FOOTER **
 ** ./src/browser/add/Page.js
 **/